export default "__VITE_ASSET__ClsNHeHX__"